export const empresasConfig = {
  hipergas: {
    nombre: 'Hipergas',
    apiBaseUrl: 'https://mphipergas.netizar.com',
    // apiBaseUrl: 'http://localhost:3002',
    color: '#009ee3',
    localStorageKey: 'user_hipergas',
    id:1,
    mpEmpresa: 1
  },
  naturalgas: {
    nombre: 'Naturalgas',
    // apiBaseUrl: 'http://localhost:3002',
    apiBaseUrl: 'https://mpnatural.netizar.com',
    color: '#00a859',
    localStorageKey: 'user_naturalgas',
    id:4,
    mpEmpresa: 2
  }
};

// export const empresasConfig = {
//   hipergas: {
//     nombre: 'Hipergas',
//     apiBaseUrl: 'https://mphipergas.netizar.com',
//     // apiBaseUrl: 'http://localhost:3002',
//     color: '#009ee3',
//     localStorageKey: 'user_hipergas',
//     id:1,
//     mpEmpresa: 1
//   },
//   naturalgas: {
//     nombre: 'Naturalgas',
//     // apiBaseUrl: 'http://localhost:3002',
//     apiBaseUrl: 'https://mpdevnatural.netizar.com',
//     color: '#00a859',
//     localStorageKey: 'user_naturalgas',
//     id:4,
//     mpEmpresa: 2
//   }
// };